import React, {useCallback, useMemo, useState} from 'react';
import {MatchListContainer} from "../../styled/SummonerStyle";
import RestDayInfo from "../summoner/MatchList/RestDayInfo";
import {getTierScore} from "../../function";
import {useSelector} from "react-redux";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import SllMatchItem from "./sllMatchTemp";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const MatchBox = styled.div`
  width: 600px;
`;

const SllMatchList = ({matchList, targetSummoner, isMore, setPage}) => {
    const {t} = useTranslation()
    const targetInfo = useMemo(() => {
        try {
            const me = matchList[0].participants_list.find((data) => data.pro_streamer_name === targetSummoner.name)
            return {
                ...targetSummoner,
                ...me,
            }
        } catch (e) {
            console.log(e)
            return {
                ...targetSummoner,
                puu_id: "",
                riot_id_name: "",
                riot_id_tag_line: "",
                pro_streamer_name: "",
            }
        }
    }, [targetSummoner, matchList]);

    const [openId, setOpenId] = useState(0);

    const currentLang = useSelector((state) => state.translation.lang);
    const separatingMatchByTakeARest = useMemo(() => {
        if (Array.isArray(matchList) && matchList.length > 0) {
            //4 hours == 3600 * 4
            return matchList.reduce((sum, cur, index) => {
                if (cur && index > 0) {
                    const restTime = 3600 * 4;
                    const currentMatchTime = Number(Number(cur?.match_basic_dict.creation_timestamp) + Number(cur?.match_basic_dict.game_duration));
                    const duration = Number(cur?.match_basic_dict.game_duration);

                    if (sum[sum.length - 1].lastMatchStamp > currentMatchTime) {
                        const timeCalc = Number(sum[sum.length - 1].lastMatchStamp) - Number(currentMatchTime);
                        if (timeCalc - restTime > 0) {
                            sum.push({
                                timestamp: currentMatchTime,
                                lastMatchStamp: currentMatchTime,
                                duration: duration,
                                match: [{...cur},],
                            })
                        } else {
                            sum[sum.length - 1].lastMatchStamp = currentMatchTime;
                            sum[sum.length - 1].duration += duration;
                            sum[sum.length - 1].match.push({...cur});
                        }
                    }
                }
                return sum;
            }, [{
                timestamp: matchList[0].match_basic_dict.creation_timestamp + matchList[0].match_basic_dict.game_duration,
                lastMatchStamp: Number(matchList[0].match_basic_dict.creation_timestamp) + Number(matchList[0].match_basic_dict.game_duration),
                match: [{...matchList[0]}],
                duration: matchList[0].match_basic_dict.game_duration,
            }]);

        }
        return [];
    }, [matchList]);

    const getAvgTier = useCallback((match,) => {
        try {
            const playerList = match.participants_list;
            const filterUnrank = playerList.filter((data) => data.tier !== "unranked");
            const combinedPlayerTier = filterUnrank.reduce((sum, cur) => {
                sum += getTierScore(`${cur.tier} ${cur.division}`).num;
                return sum;
            }, 0);
            const length = filterUnrank.length === 0 ? 1 : filterUnrank.length;
            return getTierScore(Math.trunc(combinedPlayerTier / length)).num;
        } catch (e) {
            console.log("avgTier", e);
            return 0;
        }
    }, []);
    const handleMoreInfo = (gameId) => {
        const currentId = openId;
        if (currentId === gameId) {
            setOpenId(0);
        } else {
            setOpenId(gameId);
        }
    };


    const myMatch = (match, summoner) => {
        try {
            const list = match?.participants_list
            if (Array.isArray(list)) {
                let nameItem = list.find((data) => data?.pro_streamer_name === summoner?.summoner_basic_info_dict?.pro_streamer_name);
                if (nameItem) {
                    return nameItem
                }
                let item = list.find((data) => data?.puu_id === summoner?.summoner_basic_info_dict?.puu_id);
                if (typeof item === 'object') {
                    return item
                }
            }
            return false
        } catch (e) {
            console.log(match?.participants_list, summoner)
            return {}
        }
    }

    if (!targetInfo.riot_id_name) return null
    return (
        <Wrapper>
            <MatchBox>
                <MatchListContainer>
                    {separatingMatchByTakeARest.map((separate, index) => {
                        const time = separate.timestamp;
                        const myMatches = separate.match.reduce((sum, data) => {
                            const thisMatch = data.participants_list.find((player) => player?.puu_id === targetInfo.puu_id)
                            if (thisMatch) {
                                sum.push(thisMatch);
                            }
                            return sum;
                        }, []);
                        const tierNumberMap = separate.match.map((item) => getAvgTier(item));
                        return (
                            <React.Fragment key={separate.timestamp}>
                                <RestDayInfo
                                    timestamp={time}
                                    currentLang={currentLang}
                                    myMatch={myMatches}
                                    tierArray={tierNumberMap}
                                    duration={separate.duration}
                                />
                                {separate.match.map((match, index) => {
                                    if (match?.participants_list?.length === 0) {
                                        return null
                                    }
                                    if (!myMatch(match, {
                                        summoner_basic_info_dict: {
                                            puu_id: targetInfo.puu_id,
                                            riot_id_name: targetInfo.riot_id_name,
                                            riot_id_tag_line: targetInfo.riot_id_tag_line,
                                            pro_streamer_name: targetInfo.pro_streamer_name
                                        }
                                    })) {
                                        return null
                                    }
                                        return (
                                            <SllMatchItem
                                                sllMode={true}
                                                key={match.match_basic_dict.match_id + "match"}
                                                summoner={{
                                                    summoner_basic_info_dict: {
                                                        puu_id: targetInfo.puu_id,
                                                        riot_id_name: targetInfo.riot_id_name,
                                                        riot_id_tag_line: targetInfo.riot_id_tag_line,
                                                        pro_streamer_name: targetInfo.pro_streamer_name
                                                    }
                                                }}
                                                currentLang={currentLang}
                                                region={'KR'}
                                                match={match}
                                                openId={openId === match.match_basic_dict.match_id}
                                                handleMoreInfo={handleMoreInfo}
                                            />
                                        );
                                })}
                            </React.Fragment>
                        )
                    })}

                </MatchListContainer>
            </MatchBox>
        </Wrapper>
    );
};

export default SllMatchList;